import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'sonner';
import { Inbox, Phone, Mail, Check } from 'lucide-react';

const SERVICE = { 'house-removals': 'House removal', 'man-and-van': 'Man and van', 'office-removals': 'Office removal', 'furniture-delivery': 'Furniture delivery', 'rubbish-clearance': 'Clearance', 'long-distance': 'Long-distance', other: 'Other' };

export const AdminEnquiries = ({ authFetch }) => {
  const [list, setList] = useState(null);
  const load = useCallback(() => authFetch('get', '/admin/enquiries?days=30').then(({ data }) => setList(data.enquiries)).catch(() => setList([])), [authFetch]);
  useEffect(() => { load(); }, [load]);
  const toggle = async (e) => {
    try { await authFetch('post', `/admin/enquiries/${e.id}/handled`); load(); } catch { toast.error("Couldn't update."); }
  };
  if (!list) return null;
  const open = list.filter(e => !e.handled).length;
  return (
    <section className="rounded-xl border border-slate-200 bg-white p-4" data-testid="admin-enquiries">
      <div className="flex items-center gap-2 mb-3">
        <Inbox className="w-4 h-4 text-[color:var(--mv-orange)]" />
        <h2 className="font-display font-black text-[color:var(--mv-navy)]">Contact form enquiries</h2>
        <span className="text-xs text-slate-500" data-testid="admin-enquiries-count">{open} to reply · last 30 days</span>
      </div>
      {list.length === 0 ? <div className="text-sm text-slate-500">No contact form enquiries yet.</div> : (
        <div className="divide-y divide-slate-100">
          {list.map(e => (
            <div key={e.id} className={`py-2.5 flex flex-wrap items-start gap-x-4 gap-y-1 ${e.handled ? 'opacity-60' : ''}`} data-testid={`enquiry-${e.ref}`}>
              <div className="min-w-[180px]">
                <div className="font-bold text-sm text-[color:var(--mv-navy)]">{e.name} <span className="text-[10px] font-black text-slate-400">#{e.ref}</span></div>
                <div className="text-xs text-slate-500">{new Date(e.created_at).toLocaleString('en-GB', { dateStyle: 'medium', timeStyle: 'short' })} · {SERVICE[e.service] || e.service}{e.date ? ` · wanted ${e.date}` : ''}</div>
              </div>
              <div className="text-xs text-slate-600 flex-1 min-w-[200px]">
                {(e.from_area || e.to_area) && <div>{e.from_area || '—'} → {e.to_area || '—'}</div>}
                {e.notes && <div className="italic">“{e.notes}”</div>}
              </div>
              <div className="flex items-center gap-2">
                <a href={`tel:${e.phone}`} className="h-8 px-2.5 rounded border border-slate-200 text-xs font-bold inline-flex items-center gap-1"><Phone className="w-3 h-3" />{e.phone}</a>
                {e.email && <a href={`mailto:${e.email}`} className="h-8 px-2.5 rounded border border-slate-200 text-xs font-bold inline-flex items-center gap-1"><Mail className="w-3 h-3" />Email</a>}
                <button type="button" onClick={() => toggle(e)} className={`h-8 px-2.5 rounded text-xs font-bold inline-flex items-center gap-1 ${e.handled ? 'border border-slate-200' : 'bg-emerald-600 text-white'}`} data-testid={`enquiry-handled-${e.ref}`}><Check className="w-3 h-3" />{e.handled ? 'Replied' : 'Mark replied'}</button>
              </div>
            </div>
          ))}
        </div>
      )}
    </section>
  );
};
